import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { ButtonClean, ModalBox, useModalContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import type { SyncedProduct } from '../../AppsTiktokShop.types'
import * as S from './ProductsSyncStatusModal.styled'

export type ProductsStatusModalProps = {
  title: string
  products: SyncedProduct[]
}

export const ProductsSyncStatusModal = ({ title, products }: ProductsStatusModalProps) => {
  const { close } = useModalContext()

  return (
    <ModalBox title={title} onClose={close}>
      <S.Container>
        {products.map((product) => (
          <S.ProductContainer>
            <S.ProductImageContainer>
              <PhotoThumbnail url={product.imageSrc} size="tiny" />
            </S.ProductImageContainer>
            <S.ProductContentContainer>
              <S.ProductName
                href={reverse(routing.products.all.product.self, { productId: product.id })}
                target="_blank"
                rel="noopener noreferrer"
              >
                {product.name}
              </S.ProductName>
              {product.issues.length > 0 && (
                <S.ProductDescription>
                  {product.issues.map((issue) => (
                    <S.ProductDescriptionItem>
                      {issue.description}{' '}
                      {issue.url && (
                        <>
                          (<ButtonClean label="Learn more" href={issue.url} target="_blank" />)
                        </>
                      )}
                    </S.ProductDescriptionItem>
                  ))}
                </S.ProductDescription>
              )}
            </S.ProductContentContainer>
          </S.ProductContainer>
        ))}
      </S.Container>
    </ModalBox>
  )
}
